import { render, staticRenderFns } from "./AllocatedBundles.vue?vue&type=template&id=c2b97790&"
import script from "./AllocatedBundles.vue?vue&type=script&lang=js&"
export * from "./AllocatedBundles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports